import { WfaSessionNameQuery } from '../WfaSessionName.generated';

export const transformWfaSessionNameResults = (result: WfaSessionNameQuery): string =>
	result?.wfa_session_runs?.[0]?.session_name ?? '';
